/**
 * Normalize a string by decomposing Unicode characters and stripping
 * diacritical marks (accents), then lowercasing.
 *
 * e.g. "Glashütte" → "glashutte", "Zürich" → "zurich", "Breguet" → "breguet"
 */
export function normalizeText(text: string): string {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}
